import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import packageJson from 'package.json';

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
  constructor() {}

  public apiUrl = environment.apiUrl;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (environment.CUSTOMIZATION.RTLS_MODE !== 'BROWSER') {
      request = request.clone({
        setParams: {
          version: packageJson.hash,
        },
      });
    }
    return next.handle(request);
  }
}
